import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=db6b1b2c"
import script from "./StoreList.vue?vue&type=script&lang=ts"
export * from "./StoreList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports